// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2JH9Q","buttons":"PendingPaymentAlert_buttons__1AUtI"};